// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1lk6g","tab":"Tabs_tab__1YEgM","tabActive":"Tabs_tabActive__1ws4G"};